document.addEventListener('DOMContentLoaded', () => {
    console.log('Events by Verdant Spark');
    document.querySelectorAll('.js-qty__adjust--plus').forEach(el=>{
        el.addEventListener('click', (evt) => {
            const productId = evt.target.dataset.pid;
            changeQty(1, productId);
        });
    });
    document.querySelectorAll('.js-qty__adjust--minus').forEach(el=>{
        el.addEventListener('click', (evt) => {
            const productId = evt.target.dataset.pid;
            changeQty(-1, productId);
        });
    });
    document.querySelectorAll('.event-quick-add').forEach(form=>{
        form.addEventListener('submit', addToCart);
    });
});

const changeQty = (amount, productId) => {
    let updateQty;
    const qtyElement = document.getElementById(`Quantity-${productId}`);
    const currentQty = parseInt(qtyElement.value);
    const minQty = parseInt(qtyElement.min);
    if (currentQty + amount < minQty) {
        updateQty = minQty;
    }
    else {
        updateQty = currentQty + amount;
    }
    qtyElement.value = updateQty;
};

const addToCart = (evt) => {
    evt.preventDefault();
    const button = evt.submitter;
    button.classList.add('btn--loading');
    const form = evt.target;
    let formData = new FormData(form);
    fetch('/cart/add.js', {
        method: 'POST',
        body: formData
    }).then(() => {
        button.classList.remove('btn--loading');
        document.dispatchEvent(new CustomEvent('cart:build'));
    });
};